
import newIo from '@/lib/io/promiseIo'
import conf from '@/lib/conf'
import io from '../lib/io'

// 拼 query
function getQuery (obj) {
    let temp = ''
    const keys = Object.keys(obj)
    keys.forEach((i, index)=>{
        if(index != keys.length) {

            temp += i + '=' + obj[i] + '&'
        } else {
            temp += i + '=' + obj[i]
        }
    })
    return temp
    
}

//uc

export function ucLogin(params) {
    return newIo.post(`${conf.ucServer}/oauth/token`, params)
}

//yyfn-api

export function synLoadAreams(){
    let areaTeams = []
    io.syncPost(io.getAreaTeams,{},(res)=>{
        areaTeams = res.data
    })
    return areaTeams
}

export function sendCode3(params) {
    return newIo.post(`${conf.baseApiPath}/yyfn-api/api/sms/sendCode3`, params)
}

export function findCustomerBindStudent() {
    return newIo.post(`${conf.baseApiPath}/yyfn-api/api/m/u/findCustomerBindStudent`)
}

export function getUser() {
    return newIo.post(`${conf.baseApiPath}/yyfn-api/api/m/u/getUser`)
}

export function getStat() {
    return newIo.post(`${conf.baseApiPath}/yyfn-api/api/m/u/stat`)
}

export function unbindWxOpenId(){
    return newIo.post(`${conf.baseApiPath}/yyfn-api/api/m/u/unbindWxOpenId`)
}

// export function bindPhoneNo(params){
//     return newIo.post(`${conf.baseApiPath}/yyfn-api/api/m/wx/bindPhoneNo`,params)
// }

// export function autoBindStudent(params){
//     return newIo.post(`${conf.baseApiPath}/yyfn-api/api/m/u/autoBindStudent`,params)
// }

// export function autoBindStudent2(){
//     return newIo.post(`${conf.baseApiPath}/yyfn-api/api/m/u/autoBindStudent2`)
// }

export function calPrice(params){
    return newIo.postPlayload(`${conf.baseApiPath}/yyfn-api/api/m/u/calPrice`,params)
}

export function checkRegAvailable(params){
    return newIo.post(`${conf.baseApiPath}/yyfn-api/api/m/checkRegAvailable`,params)
}

export function loadStudentBalance(params){
    return newIo.post(`${conf.baseApiPath}/yyfn-api/api/m/u/studentBalance`,params)
}

export function queryDiscountCode(params){
    return newIo.postPlayload(`${conf.baseApiPath}/yyfn-api/api/m/u/queryDiscountCode`,params)
}

export function preCreateOrder(){
    return newIo.post(`${conf.baseApiPath}/yyfn-api/api/m/u/preCreateOrder`)
}

export function createOrder(params){
    return newIo.postPlayload(`${conf.baseApiPath}/yyfn-api/api/m/u/createOrder`,params)
}

export function savePayInfo(params){
    return newIo.postPlayload(`${conf.baseApiPath}/yyfn-api/api/m/u/savePayInfo`,params)
}

export function loadUserOrders(params){
    return newIo.post(`${conf.baseApiPath}/yyfn-api/api/m/u/userOrders`,params)
}

export function getOrder(params){
    return newIo.post(`${conf.baseApiPath}/yyfn-api/api/m/u/getOrder`,params)
}

export function cancelOrder(params){
    return newIo.post(`${conf.baseApiPath}/yyfn-api/api/m/u/cancelOrder`,params)
}

export function loadStudentStudentRegs(params){
    return newIo.postPlayload(`${conf.baseApiPath}/yyfn-api/api/m/u/studentStudentRegs`,params)
}

export function loadShareItems(params){
    return newIo.postPlayload(`${conf.baseApiPath}/yyfn-api/api/m/queryShareItems`,params)
}

export function loadCourseClassesByIds(classIds){
    return newIo.postPlayload(`${conf.baseApiPath}/yyfn-api/api/m/queryCourseClassesByIds`,classIds)
}

//cc-api
export function loadCloudClassCourse(params){
    return newIo.post(`${conf.baseApiPath}/cc-api/api/m/u/queryStudentCourse`,params)
}

export function loadCloudClassCourseWithVideo(params){
    return newIo.post(`${conf.baseApiPath}/cc-api/api/m/u/getCourseWithVideo`,params)
}

export function logWatchTimeOfCloudClassCourseVideo(params){
    return newIo.post(`${conf.baseApiPath}/cc-api/api/m/u/watch/log`,params)
}

//mc-api
export function saveUserFormData(params){
    return newIo.postPlayload(`${conf.baseApiPath}/mc-api/api/m/saveUserFormData`,params)
}

export function preparePayForCharging(params){
    return newIo.postPlayload(`${conf.baseApiPath}/mc-api/api/m/charging/preparePay`,params)
}

export function deleteUserFormData(params){
    return newIo.post(`${conf.baseApiPath}/mc-api/api/m/deleteUserFormData`,params)
}



// other
export function locationCity(){
    let city = '广州市';
    io.syncPost('https://restapi.amap.com/v3/ip?key=b8930aa454d4708ca5603110c001cfb7',{},(res)=>{
        if(res.status == 1 ){
            city = res.city
        }
    })
    return city
}

//优惠券
export function getCouponActivity(couponActivityId){
    return newIo.post(io.getCouponActivity, {couponActivityId})
}
export function isReleaseCoupon(params){
    return newIo.post(io.isReleaseCoupon, {...params})
}
export function releaseCoupon(params){
    return newIo.post(io.releaseCoupon, {...params})
}
export function myShareRecord(params){
    return newIo.post(io.myShareRecord, {...params})
}
export function logBack(params){
    return newIo.post(io.logBack, {...params})
}
export function shareCoupon(params){
    return newIo.post(io.shareCoupon, {...params})
}
export function queryMyCoupons(){
    return newIo.post(io.queryMyCoupons)
}
export function queryCandidateCoupon(params){
    return newIo.postPlayload(io.queryCandidateCoupon, params)
}

// 添加购物车
export function addToCart(params){
    return newIo.postPlayload(io.addToCart, params)
}
export function deleteShoppingCart(params){
    return newIo.postPlayload(io.deleteCart, params)
}


// WEBPACK FOOTER //
// ./src/api/index.js